import { ShieldCheck, Lock, EyeOff, Globe2, Database } from "lucide-react";

const items = [
  { Icon: ShieldCheck, label: "GDPR compliant" },
  { Icon: Lock, label: "SOC 2 (in progress)" },
  { Icon: EyeOff, label: "100% anonymous by design" },
  { Icon: Globe2, label: "EU data residency" },
  { Icon: Database, label: "PII auto-strip pre-database" },
];

export const SecurityBand = () => {
  return (
    <section className="container mx-auto px-3 lg:px-8 py-12">
      <div className="rounded-3xl bg-white border border-border mkt-shadow-card px-6 sm:px-10 py-8">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="max-w-md">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[hsl(var(--mkt-primary))] mb-2">
              Security & compliance
            </div>
            <h3 className="text-2xl lg:text-3xl font-bold tracking-tight">
              Built For HR. Trusted By Legal.
            </h3>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            {items.map(({ Icon, label }) => (
              <div
                key={label}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[hsl(var(--mkt-primary)/0.08)] text-[hsl(var(--mkt-primary-deep))] text-sm font-medium"
              >
                <Icon className="h-4 w-4" />
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
